import { render, staticRenderFns } from "./historyReport.vue?vue&type=template&id=245e56f4&scoped=true"
import script from "./historyReport.vue?vue&type=script&lang=js"
export * from "./historyReport.vue?vue&type=script&lang=js"
import style0 from "./historyReport.vue?vue&type=style&index=0&id=245e56f4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e56f4",
  null
  
)

export default component.exports